import React from 'react';
import { Box } from '@blueprint/ui';
import useReCaptcha from '../../hooks/useReCaptcha';

const Recaptcha = ({ onVerification, onExpiry, action, resetCaptcha }) => {
    useReCaptcha({ onVerification, onExpiry, action, resetCaptcha });
    return <Box id='recaptcha'></Box>;
};

export default Recaptcha;
